import PageHero from "../components/sections/PageHero";
import SectionLabel from "../components/ui/SectionLabel";

const cardStyle: React.CSSProperties = {
  background: "#0E0E0E",
  border: "1px solid rgba(212,168,67,0.18)",
  borderRadius: 4,
  padding: "32px 28px",
};

const bodyStyle: React.CSSProperties = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 15,
  color: "#8B8378",
  lineHeight: 1.8,
  fontWeight: 300,
};

const TermsOfService = () => (
  <>
    <PageHero
      label="LEGAL"
      title="Terms of"
      titleAccent="service."
      subtitle="Basic terms governing use of this website and how project engagements move from enquiry to delivery."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div style={{ marginBottom: 32 }}>
          <SectionLabel text="LAST UPDATED" />
          <p style={{ ...bodyStyle, marginTop: 16 }}>March 20, 2026</p>
        </div>

        <div style={{ display: "grid", gap: 20 }}>
          {[
            {
              title: "Website use",
              body:
                "You may use this website to learn about Obsidian Web Labs and contact us about potential work. You agree not to misuse the website, interfere with its operation, or attempt to gain unauthorized access to any connected systems.",
            },
            {
              title: "Project discussions",
              body:
                "Information on this site is for general guidance only. A project begins only after both parties confirm scope, timeline, and commercial terms in writing. Proposals and discovery conversations do not create a delivery obligation on either side until an agreement is signed.",
            },
            {
              title: "Payments and delivery",
              body:
                "Payment schedules, milestone definitions, revisions, change requests, support windows, and delivery expectations are governed by the applicable proposal, statement of work, or service agreement for each engagement.",
            },
            {
              title: "Intellectual property",
              body:
                "Unless a separate written agreement states otherwise, all content, branding, and materials on this website remain the property of Obsidian Web Labs. Project-specific ownership and licensing terms are handled in client contracts.",
            },
            {
              title: "No warranty for website content",
              body:
                "We work to keep website information accurate and current, but we do not guarantee that every page is complete, uninterrupted, or error-free at all times. We may update, remove, or improve content without prior notice.",
            },
            {
              title: "Contact",
              body:
                "Questions about these terms can be sent to obsidianweblabs@gmail.com. Continued use of the website after updates means you accept the revised terms as posted here.",
            },
          ].map((section) => (
            <article key={section.title} style={cardStyle}>
              <h2
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontSize: 34,
                  color: "#F8F4EC",
                  marginBottom: 12,
                }}
              >
                {section.title}
              </h2>
              <p style={bodyStyle}>{section.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default TermsOfService;
